import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { GiftSource } from 'lib/_types/gift'

export const giftBoxSlice = createSlice({
  name: 'giftBox',
  initialState: {
    source: {},
  },
  reducers: {
    setGiftBoxSource: (
      state,
      actions: PayloadAction<{
        type: GiftSource
      }>
    ) => {
      state.source = actions.payload
    },
    clearGiftBoxSource: (state, _actions: PayloadAction) => {
      state.source = {}
    },
  },
})

export const selectGiftBoxSource = createSelector(
  (state: any) => state.giftBox,
  (state) => state.source
)

export const { setGiftBoxSource, clearGiftBoxSource } = giftBoxSlice.actions

export default giftBoxSlice.reducer
